export default function () {
  const widgetName = 'cardsWidget';
  const widgetOpts = cardsWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    itemsPerPanel: 6,
    maxItemsVisible: 6,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,

    cardWidgetLoaded: function (data) {
      const widgetData = data.items;

      if (widgetData.length < 1) {
        $(`#tier-2-container .inner-container`).remove();
      } else {
        createCustomCards(widgetData);
      }
    },
  });

  function createCustomCards(widgetData) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      const { Title, URL } = widgetData[x];
      const $card = $(this);

      const titleShape = `
        <div class="overlay"></div>
        <span class="card-title-container">
          <span class="card-title">
          ${Title}
          </span>
        </span>
      `;

      $card.removeAttr('target');
      $card.find('.card-content').replaceWith(titleShape);
      $card.find('.overlay').appendTo($card);
      $card.find('.card-title-container').appendTo($card);

      if (!URL) {
        $card.removeAttr('href');
      }
    });
  }
}
